import { render } from "./JOnwork.vue?vue&type=template&id=b585c4c0&scoped=true&ts=true"
import script from "./JOnwork.vue?vue&type=script&lang=ts"
export * from "./JOnwork.vue?vue&type=script&lang=ts"

import "./JOnwork.vue?vue&type=style&index=0&id=b585c4c0&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b585c4c0"]])

export default __exports__